// @flow

import ButtonComponent from './ButtonComponent';
import DeleteComponent from './DeleteComponent';
import QuickViewComponent from './QuickViewComponent';

const ACTION_TYPES = {
    button: ButtonComponent,
    delete: DeleteComponent,
    quickView: QuickViewComponent,
};

export default ACTION_TYPES;
